import Forbidden from "@Pages/Error/Forbidden";
import { Suspense, lazy, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@Reducers/index";

const ReviewFlows = lazy(
  () => import("../../../../components/SpaceSettings/UserAdministration/ReviewFlows/ReviewFlows"),
);
const ReviewFlowDetails = lazy(
  () => import("../../../../components/SpaceSettings/UserAdministration/ReviewFlows/ReviewFlowDetails"),
);

interface ReviewFlowsWrapperProps {
  projectId: string;
}

function ReviewFlowsWrapper({ projectId }: ReviewFlowsWrapperProps) {
  const [reviewFlowId, setReviewFlowId] = useState("");
  const getProjectSettingObject = useSelector((state: RootState) => state.getProjectSettingObject);

  // Derived directly from the permission object — no need for state + effect.
  const hasAccess = Boolean(getProjectSettingObject?.reviewFlow?.add?.enable);

  const handleReviewFlowChange = (id: string) => {
    setReviewFlowId(id);
  };

  return (
    <>
      {!reviewFlowId ? (
        <Suspense>
          {hasAccess ? (
            <ReviewFlows handleReviewFlowChange={handleReviewFlowChange} projectId={projectId} />
          ) : (
            <Forbidden />
          )}
        </Suspense>
      ) : (
        <Suspense>
          <ReviewFlowDetails
            handleReviewFlowChange={handleReviewFlowChange}
            reviewFlowId={reviewFlowId}
            projectId={projectId}
          />
        </Suspense>
      )}
    </>
  );
}

export default ReviewFlowsWrapper;
